import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Hellosection = ({winningdata}) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="cfan-winning-section">
        <div className="container">
            <div className="winning-wrapper d-flex justify-content-between align-items-center">
                <div className="winning-content">
                    <h3>{winningdata.textone}</h3>
                </div>
                <div className="winning-logo-cfan">
                    <img src={winningdata.img} alt=""/>
                </div>
            </div>
        </div>
    </section>
  );
};

export default Hellosection;